import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-paper text-ink" data-id="element-173" data-mp="uyksaz99jqmd">
      <a href="#contenu" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:bg-ink focus:px-4 focus:py-2 focus:text-paper" data-id="element-174" data-mp="uwgp6jj6uvn5">
        Aller au contenu
      </a>
      <Header data-id="element-175" data-mp="gy9zvrsb23z3" />
      <main id="contenu" className="flex-1" data-id="element-176" data-mp="gys2d65k9efg">
        <Outlet data-id="element-177" data-mp="gzuwdmy6jwzl" />
      </main>
      <Footer data-id="element-178" data-mp="c83cfv9j4pif" />
    </div>;
}